import { createSelector } from 'reselect'

import { RootState } from 'redux/store'

const selectAolName = createSelector(
  (state: RootState) => state.aol.name,
  (name: string) => name
)

export default selectAolName
